<template>
  <div class="card" style="min-height: 300px;">
    <div class="p-3 pb-0 card-header">
      <div class="d-flex align-items-center">
        <h6 class="mb-0">{{ title }}</h6>
      </div>
    </div>
    <div class="p-3 card-body">
      <div class="row">
        <div class="text-center col-12" style="height:200px">
          <div class="chart">
            <canvas :id="id" class="chart-canvas" height="200"></canvas>
          </div>
          <h4 class="font-weight-bold mt-n8">
            
          </h4>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6 mb-2" :key="item" v-for="(item, index) in datas">
          <div class="row">
            <div class="col-md-9">
              <div class="px-2 py-0 d-flex">
                <span class="badge me-2" v-bind:style="{ backgroundColor: colors[index]}">&nbsp;</span>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="mb-0 text-sm">{{labels[index]}}</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="d-flex flex-column align-items-end">
                <h6 class="mb-0 text-sm">{{item}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "consumption-by-room-chart",
  props: {
    labels: Array,
    id: String,
    datas: Array,
    colors: Array,
    title: String,
  },
  mounted() {
    // Chart Doughnut Consumption by room
    var ctx1 = document.getElementById(this.id).getContext("2d");

    new Chart(ctx1, {
      type: "doughnut",
      data: {
        labels: this.labels,
        datasets: [
          {
            label: this.title,
            weight: 9,
            cutout: 50,
            tension: 1,
            pointRadius: 2,
            borderWidth: 2,
            backgroundColor: this.colors,
            data: this.datas,
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
        scales: {
          y: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: false,
              drawTicks: false,
            },
            ticks: {
              display: false,
            },
          },
          x: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: false,
              drawTicks: false,
            },
            ticks: {
              display: false,
            },
          },
        },
      },
    });
    this.$forceUpdate();
  },
};
</script>
